var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"rating-list"},_vm._l((_vm.lists),function(list,index){return _c('li',{key:index,staticClass:"selective-list"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.lang[list.lang]))]),_c('Star',{attrs:{"max":_vm.max,"rating":list},on:{"ratings":_vm.checkRatings}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }